<template>
  <div class="wrapper">
    <h1 id="heading">Add New Store</h1>

    <div class="config" v-if="localStore">
      <div id="titleDiv" class="row">
        <div class="flex" style="display: flex; align-items: center">Title:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-input
            label="Store Name"
            v-model="storeTitle"
            @change="storeChanged"
            placeholder="Store Title"
            style="display: flex; align-self: bottom"
          />
        </div>
      </div>

      <div class="row">
        <div class="flex" style="display: flex; align-items: center">Square Authentication Key:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-input
            label="Square Auth Key"
            v-model="authKey"
            placeholder="Auth Id"
            style="display: flex; align-self: bottom"
          />
        </div>
      </div>

      <div class="row">
        <div class="flex" style="display: flex; align-items: center">Square App Id:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-input
            label="Square App Id"
            v-model="appId"
            placeholder="App Id"
            style="display: flex; align-self: bottom"
          />
        </div>
      </div>

      <div class="row">
        <div class="flex" style="display: flex; align-items: center">Square Location Id:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-input
            label="Square Location Id"
            v-model="locationId"
            placeholder="Location Id"
            style="display: flex; align-self: bottom"
          />
        </div>
      </div>

      <div id="addressDiv">
        <h1>Address</h1>

        <div class="row">
          <div class="flex" style="display: flex; align-items: center">Street:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-input
              label="Street"
              v-model="storeStreet"
              placeholder="Store Street"
              style="display: flex; align-self: bottom"
              @change="storeChanged"
            />
          </div>
        </div>

        <div class="row">
          <div class="flex" style="display: flex; align-items: center">City:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-input
              label="City"
              v-model="storeCity"
              placeholder="Store City"
              style="display: flex; align-self: bottom"
              @change="storeChanged"
            />
          </div>
        </div>

        <div class="row">
          <div class="flex" style="display: flex; align-items: center">State:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-input
              label="State"
              v-model="storeState"
              placeholder="Store State"
              style="display: flex; align-self: bottom"
              @change="storeChanged"
            />
          </div>
        </div>

        <div class="row">
          <div class="flex" style="display: flex; align-items: center">Zip Code:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-input
              label="Zip Code"
              v-model="storeZip"
              placeholder="Store Zip Code"
              style="display: flex; align-self: bottom"
              @change="storeChanged"
            />
          </div>
        </div>
      </div>
      <br />

      <div id="themeDiv">
        <h1>App Theme</h1>

        <div id="mainFontDiv" class="row">
          <div class="flex" style="display: flex; align-items: center">Main Font:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-select label="Main Font" v-model="mainFont" searchable textBy="description" :options="fontList" />
          </div>
        </div>

        <div id="titleFontDiv" class="row">
          <div class="flex" style="display: flex; align-items: center">Title Font:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-select label="Title Font" v-model="titleFont" searchable textBy="description" :options="fontList" />
          </div>
        </div>

        <div id="lightDiv" class="row">
          <div class="flex" style="display: flex; align-items: center">Light:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-toggle v-model="light" @change="storeChanged" />
          </div>
        </div>

        <div id="primaryColorDiv">
          <h2>Primary Color</h2>

          <div class="row">
            <div class="flex md1">
              <va-color-square :value="primaryColor" />
            </div>
            <div class="flex md7">
              <va-advanced-color-picker v-model="primaryColor" />
            </div>
          </div>
        </div>

        <div id="accentColorDiv">
          <h2>Accent Color</h2>

          <div class="row">
            <div class="flex md1">
              <va-color-square :value="accentColor" />
            </div>
            <div class="flex md7">
              <va-advanced-color-picker v-model="accentColor" />
            </div>
          </div>
        </div>
      </div>

      <va-button @click="addStore()" :disabled="!validStore">Add Store</va-button>
    </div>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebaseConfig')

export default {
  name: 'AddStorePage',
  methods: {
    storeChanged: function () {
      console.log('Chagne')
    },
    addStore: async function () {},
  },
  computed: {
    validStore: function () {
      return (
        this.storeTitle !== '' &&
        this.appId !== '' &&
        (this.locationId !== '') & (this.authKey !== '') &&
        this.storeCity !== '' &&
        this.storeStreet !== '' &&
        this.storeState !== '' &&
        this.storeZip !== 0 &&
        this.mainFont !== '' &&
        this.titleFont !== ''
      )
    },
  },
  mounted: async function () {
    var getFonts = fb.funcs.httpsCallable('getGoogleFonts')
    this.fontList = (await getFonts({})).data.map((font) => font.family)
  },
  data() {
    return {
      storeTitle: '',
      storeStreet: '',
      storeCity: '',
      storeState: '',
      storeZip: 0,
      mainFont: '',
      titleFont: '',
      appId: '',
      locationId: '',
      authKey: '',
      light: false,
      primaryColor: [0, 0, 0],
      accentColor: [0, 0, 0],
      fontList: ['Loading Font options...'],
      localStore: {
        type: Object,
        required: false,
        default: { title: 'No Store', coupons: [] },
      },
    }
  },
}
</script>

<style lang="scss">
#heading {
  font-size: 2.5em;
}
</style>
